export const HEADERS_ARRAY = [
	[<th colSpan={4}>Tickets</th>],
	[<th>Market</th>, <th>New</th>, <th>Pending</th>, <th>Priority</th>],
];
